export default __webpack_public_path__ + "static/media/beneath-the-skin.13666401.jpg";